// This route's real content is rendered by LayoutDefault.tsx's LayoutContent, which mounts
// <SrpApp> directly (server-rendered into #srp-ssr, hydrated in place — see srp.client.ts).
// Vike still requires a +Page.tsx default export to exist for this route, but for the normal
// (fullSrpViewModel present) case its output is never actually included in the render tree,
// so this stays a trivial stub. It only matters for the rare double-SSR-failure fallback in
// LayoutDefault.tsx, where it renders inside the plain SearchWrapper/SearchProvider chain.
export default function Page() {
  return null;
}
